import { createContext, useEffect, useReducer, useContext,useState } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getCurrentTime, getPathName } from "../../../common/utils/utilsFunc";

export const ConsultStateRequestContext = createContext();
export const ACTIONS = {
  SET_SERV1: "SET_SERV1",
  SET_RESPONSE_SERV1: "SET_RESPONSE_SERV1",
  SET_SERV2: "SET_SERV2",
  SET_RESPONSE_SERV2: "SET_RESPONSE_SERV2",
};
const initialState = {
  serv1: null,
  response_serv1: null,
  serv2: null,
  response_serv2: null,
};
const ConsultStateRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_SERV1: {
      return {
        ...state,
        serv1: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERV1: {
      return {
        ...state,
        response_serv1: action.payload,
      };
    }
    case ACTIONS.SET_SERV2: {
      return {
        ...state,
        serv2: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERV2: {
      return {
        ...state,
        response_serv2: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const ConsultStateRequestContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(ConsultStateRequestReducer, initialState);

  useEffect(() => {
    if (state.serv1 && (getPathName() === "consulta-estado-de-solicitud" || getPathName() === "solicitudes-y-reclamos")) {
      LiferayService.getStateRequest(properties.base_url_api, state.serv1, properties.codigo_empresa, properties.url_ws_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_SERV1,
          });
        })
    }
  }, [state.serv1]);

  useEffect(() => {
    if (state.serv2 && (getPathName() === "consulta-estado-de-solicitud" || getPathName() === "solicitudes-y-reclamos")) {
      LiferayService.getCard(properties.base_url_api, state.serv2?.numApp, properties.url_ws_empresa,properties.codigo_empresa,false)
        .then((response) => {
          const blob = new Blob([response.buffer], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(blob);
          if (!response.status) {
            let link = document.createElement('a');
            link.download = response.filename;
            link.href = fileURL
            link.click()
          }else {
            response.status = 999;
          }

          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_SERV2,
          });
        })
    }
  }, [state.serv2]);

  return (
    <ConsultStateRequestContext.Provider value={[state, dispatch]}>
      {children}
    </ConsultStateRequestContext.Provider>
  );
};
export default ConsultStateRequestContextProvider;